import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from 'convex/react';
import { api } from '@packages/backend/convex/_generated/api';
import { Spinner } from '@/components/ui/spinner';
import { m } from '@/paraglide/messages.js';

export const Route = createFileRoute('/l/$code')({
  component: ShortLinkRedirect,
});

function ShortLinkRedirect() {
  const { code } = Route.useParams();
  const navigate = useNavigate();
  const link = useQuery(api.tutor.shortLinks.resolveShortLink, { code });

  useEffect(() => {
    if (link === undefined) return; // loading

    if (link === null) return; // expired or not found — render error

    // Redirect to home with sign-in params. The questionnaireId is stamped
    // server-side by ensurePatientProfile at SMS-send time, so no client-side
    // `?q=` threading is needed.
    navigate({
      to: '/',
      search: {
        __clerk_ticket: link.ticket,
        o: link.orgSlug,
        d: link.departmentSlug,
      },
      replace: true,
    });
  }, [link, navigate]);

  if (link === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (link === null) {
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="text-center max-w-sm space-y-4">
          <img
            src="/ovet.svg"
            alt="Ovet"
            className="mx-auto size-16 opacity-50"
            width="416"
            height="388"
          />
          <h1 className="text-xl font-semibold text-gray-900">
            {m.signIn_linkUsedTitle()}
          </h1>
          <p className="text-gray-600">{m.signIn_linkUsedDescription()}</p>
          <p className="text-sm text-gray-500">{m.signIn_askClinic()}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Spinner />
    </div>
  );
}
